// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeSeparator_22f17f96 {
  width: 15.667rem;
  margin-bottom: 1rem;
  border-top: 1px solid #dce1e5;
}
.timeInputToggleContainer_22f17f96 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
}
.timeStateButton_22f17f96 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.667rem;
}
.timeInputWrapper_22f17f96 {
  width: fit-content;
  max-width: 100%;
  height: 32px;
  border: 1px solid #84919b;
  border-radius: 2px;
  text-align: center;
  padding: 4px 8px;
}
.timeInputWrapper_22f17f96 .react-time-picker {
  border: none;
}
.timeInputWrapper_22f17f96 .react-time-picker__wrapper {
  border: none;
}
.timeSwitch_22f17f96 {
  margin-bottom: ;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeSeparator": `timeSeparator_22f17f96`,
	"timeInputToggleContainer": `timeInputToggleContainer_22f17f96`,
	"timeStateButton": `timeStateButton_22f17f96`,
	"timeInputWrapper": `timeInputWrapper_22f17f96`,
	"timeSwitch": `timeSwitch_22f17f96`
};
export default ___CSS_LOADER_EXPORT___;
